import axios, { type AxiosInstance } from "axios"

/**
 * Deliberately plain, like the signing page's: the shared client attaches the
 * app's login token and turns a 401 into a trip to /login, and the caller here
 * is a customer with no account.
 */
export const customerUploadClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_ROUTE,
  validateStatus: (status: number) => status < 500
})
